import PrintActions from '../../../actions/PrintActions';
import RoutingActions from '../../../actions/RoutingActions';
import EmailReceipt from './EmailReceipt.react';

class CheckoutCompleted extends React.Component {

    constructor() {
        super();
        this.state = {
            showEmailReceipt: false,
        };
    }
    
    render() {
        var self = this;

        if (!this.props.completed)
            return null;

        var lspId = this.props.lspId,
            cart = this.props.cart,
            guest = this.props.guest;

        return (
            <div className='checkout-completed'>
            { !this.state.showEmailReceipt &&
            <div>
                <div className='checkout-completed__title'>
                    { (lspId !== 1079 && lspId !== 1091) ? 'Transaction' : 'Payment' } Successful
                </div>

                <div className='checkout-completed__change'>
                    Change: ${this.props.change}
                </div>

                <div
                    className='checkout-completed__print'
                    onClick={() => { PrintActions.printReceipt(guest.ShipmentId, true, 'Checkout'); }}>

                    PRINT RECEIPT
                </div>

                <div
                    className='checkout-completed__print'
                    onClick={() => { PrintActions.previewReceipt(guest.ShipmentId, true, 'Checkout'); }}>

                    PREVIEW RECEIPT
                </div>
                <div
                    className='checkout-completed__print'
                    onClick={() => { PrintActions.previewLabels(guest, cart); }}>

                    PREVIEW LABELS
                </div>

                <div
                    className='checkout-completed__print'
                    onClick={() => { this.setState({ showEmailReceipt : true }); }}>

                    EMAIL RECEIPT
                </div>


                <div
                    className='checkout-completed__gl'
                    onClick={() => { RoutingActions.updateRoute('guest-list'); }}>

                    GUEST LIST
                </div>
                <br style={{ clear: 'both'}}/>
                </div>
            }
                {
                    this.state.showEmailReceipt &&
                        <EmailReceipt
                        ShipmentId={guest.ShipmentId}
                        email={guest.Email}
                        onDone={() => { this.setState({ showEmailReceipt: false });}} />
                }
            </div>
           
        );
    }
}

export default CheckoutCompleted;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/CheckoutCompleted.react.jsx